<template lang="pug">
  .page-content
    h1.title Exportar Cadastros {{cadastros.length}}
    el-button(
        type="primary"
        @click="exportarCadastros"
    ) Exportar
    el-button(
        type="primary"
        @click="exportarCadastrosOff"
    ) Exportar OFF
    el-button(
        type="primary"
        @click="salvarAllCadastros"
    ) Salvar Todos

    el-table(
      :data='cadastros',
      element-loading-text="Carregando..."
    )
      template(slot="empty") Não há registros.
      el-table-column(
        prop='cadastro.id',
        label='Index',
        width="auto",
        sortable
      )
      el-table-column(
        prop='tipo',
        label='Tipo',
        width="auto",
        sortable
      )
      el-table-column(
        label='Acao',
        width="auto",
      )
        template(slot-scope='scope')
          el-dropdown(trigger="click" v-if="!scope.row.saved")
            el-button(type='primary', size="small")
              | Ações
            el-dropdown-menu(slot='dropdown')
              el-dropdown-item
                .flex(@click="debugCadastro(scope.row)")
                  | &nbsp Visualizar cadastro
              el-dropdown-item
                .flex(@click="saveCadastro(scope.row)")
                  | &nbsp Salvar cadastro

</template>
<script>

import { mapActions } from 'vuex'
import _ from 'lodash'
import moment from 'moment'
import emptyInformacao from '@/screens/central/cadastros/para/empty/emptySolicitacaoInformacao'
import emptyPermuta from '@/screens/central/cadastros/para/empty/emptyPermuta'
import emptyTransferenciaDireito from '@/screens/central/cadastros/para/empty/emptyTransferenciaDireito'
import emptyResgateAforamento from '@/screens/central/cadastros/para/empty/emptyResgateAforamento'
import emptyAreasPatrimoniais from '@/screens/central/cadastros/para/empty/emptyAreasPatrimoniais'

export default {

  data () {
    return {
      cadastros: []
    }
  },

  methods: {
    ...mapActions({
      getCadastrosAntigos: 'upload/getCadastrosAntigos',
      exportarOff: 'upload/exportarOff',
      salvarCadastro: 'upload/salvarImportacao'
    }),

    debugCadastro (cadastro) {
      console.log(cadastro)
    },

    async exportarCadastros () {
      this.cadastros = await this.getCadastrosAntigos()
    },

    async exportarCadastrosOff () {
      this.cadastros = await this.exportarOff()
    },

    salvarAllCadastros () {
      this.cadastros.forEach(item => {
        this.saveCadastro(item)
      })
    },

    saveCadastro (cadastro) {
      cadastro.json = JSON.parse(JSON.stringify(cadastro.cadastro, this.replaceUndefinedOrNull))

      switch (cadastro.tipo) {
        case 'INFORMACOES':
          cadastro.json = _.merge(_.cloneDeep(emptyInformacao), cadastro).json
          break
        case 'AFORAMENTO':
          cadastro.json = _.merge(_.cloneDeep(emptyResgateAforamento), cadastro).json
          this.formatConjuge(cadastro.json.interessado)
          this.formatGeorreferenciamento(cadastro.json.georreferenciamento)
          break
        case 'TRANSFERENCIA_DIREITOS':
          cadastro.json = _.merge(_.cloneDeep(emptyTransferenciaDireito), cadastro).json
          this.formatConjuge(cadastro.json.interessado)
          this.formatGeorreferenciamento(cadastro.json.georreferenciamento)
          break
        case 'AREAS_PATRIMONIAIS':
          cadastro.json = _.merge(_.cloneDeep(emptyAreasPatrimoniais), cadastro).json
          this.formatGeorreferenciamento(cadastro.json.georreferenciamento)
          break
        case 'PERMUTA':
          cadastro.json = _.merge(_.cloneDeep(emptyPermuta), cadastro).json
          this.formatConjuge(cadastro.json.interessado)
          this.formatGeorreferenciamento(cadastro.json.georreferenciamento)
          break
      }

      this.formatTelefones(cadastro.json)
      this.formatInteressado(cadastro.json.interessado)
      this.formatCadastrante(cadastro.json.cadastrante)

      cadastro.json = JSON.stringify(cadastro.json)
      cadastro.id = undefined
      cadastro.tipo = {codigo: cadastro.tipo}
      cadastro.versao_off = 'CENTRAL_INTERESSADO'
      cadastro.finalizado = false

      if (!cadastro.cadastro.exportado) {
        this.salvarCadastro(cadastro)
      }
    },

    formatInteressado (interessado) {
      if (!interessado) {
        return
      }

      interessado.pessoa.endereco.uf = interessado.pessoa.endereco.municipio.codigoEstado

      if (!interessado.pessoa.endereco.numero) {
        interessado.pessoa.endereco.numero = 0
      }

      if (interessado.pessoa.tipo === 'PF') {
        const pessoaFisica = interessado.pessoa.pessoaFisica
        pessoaFisica.ufNaturalidade = pessoaFisica.naturalidade.codigoEstado

        if (pessoaFisica.dataNascimento && !moment(pessoaFisica.dataNascimento).isValid()) {
          pessoaFisica.dataNascimento = moment(pessoaFisica.dataNascimento, 'DD MM YYYY').format()
        }
      }
    },

    formatConjuge (interessado) {
      const pessoaFisica = interessado.pessoa.pessoaFisica

      if (pessoaFisica.estadoCivil === 'CASADO' || pessoaFisica.estadoCivil === 'UNIAO_ESTAVEL' || pessoaFisica.estadoCivil === 'UNIAO_HOMOAFETIVA') {
        const pessoaConjuge = interessado.conjuge.pessoaFisica
        pessoaConjuge.ufNaturalidade = pessoaConjuge.naturalidade.codigoEstado
        pessoaConjuge.codigo = pessoaConjuge.orgaoExpedidor.estado

        if (pessoaConjuge.dataNascimento && !moment(pessoaConjuge.dataNascimento).isValid()) {
          pessoaConjuge.dataNascimento = moment(pessoaConjuge.dataNascimento, 'DD MM YYYY').format()
        }
      }
    },

    formatCadastrante (cadastrante) {
      if (!cadastrante) {
        return
      }

      cadastrante.pessoa.endereco.uf = cadastrante.pessoa.endereco.municipio.codigoEstado

      cadastrante.pessoa.nomeRazaoSocial = cadastrante.pessoa.tipo === 'PF'
        ? cadastrante.pessoa.pessoaFisica.nome : cadastrante.pessoa.pessoaJuridica.razaoSocial

      cadastrante.pessoa.cpfCnpj = cadastrante.pessoa.tipo === 'PF'
        ? cadastrante.pessoa.pessoaFisica.cpf : cadastrante.pessoa.pessoaJuridica.cnpj
    },

    formatGeorreferenciamento (georreferenciamento) {
      for (let i = 0; i < georreferenciamento.localizacoes.length; i++) {
        georreferenciamento.localizacoes[i] = georreferenciamento.localizacoes[i].geometry
      }
    },

    formatTelefones (cadastro) {
      if (_.hasIn(cadastro, ['cadastrante', 'pessoa', 'telefones'])) {
        for (let i = 0; i < cadastro.cadastrante.pessoa.telefones.length; i++) {
          cadastro.cadastrante.pessoa.telefones[i] = cadastro.cadastrante.pessoa.telefones[i].numero
        }
      }
      if (_.hasIn(cadastro, ['interessado', 'pessoa', 'telefones'])) {
        for (let i = 0; i < cadastro.interessado.pessoa.telefones.length; i++) {
          cadastro.interessado.pessoa.telefones[i] = cadastro.interessado.pessoa.telefones[i].numero
        }
      }
    },

    replaceUndefinedOrNull (key, value) {
      if (value === null || value === undefined) {
        return undefined
      }
      return value
    }

  }

}
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/screens/portal/publico/components/Exportacao.vue